import React from 'react';
import Icon from '../Icon';
import './style.scss';

const Dropdown = ({ className, title, name, children, absolute, selected, isOpen, onClick }) => {
	return (
		<div className={`dropdown ${className ? className : ''} ${absolute ? 'absolute' : ''}`}>
			<div className="dropdown-header" onClick={onClick}>
				<span className="dropdown-title">{title}</span>
				<Icon name={isOpen ? 'chevron-up' : 'chevron-down'} width="16" height="16" color="#999" />
			</div>
			{selected && <div className="dropdown-selected">{selected}</div>}
			{isOpen && (
				<div className={`dropdown-body ${isOpen ? 'expanded' : ''}`}>
					{absolute && (
						<div className="dropdown-header" onClick={onClick}>
							<span className="dropdown-title">{title}</span>
							<Icon
								name={isOpen ? 'chevron-up' : 'chevron-down'}
								width="16"
								height="16"
								color="#999"
							/>
						</div>
					)}
					{children}
				</div>
			)}
		</div>
	);
};

export default Dropdown;
